<template>
  <div>
    <van-tabs v-model="form.not_buy_type" @change="change">
      <van-tab title="全部" name="全部"></van-tab>
      <van-tab title="库存过多" name="库存过多"></van-tab>
      <van-tab title="性价比低(价高)" name="性价比低"></van-tab>
      <van-tab title="等待降价" name="等待降价"></van-tab>
      <van-tab title="没利润" name="没利润"></van-tab>
      <van-tab title="太贵" name="太贵"></van-tab>
      <van-tab title="难周转" name="难周转"></van-tab>
      <van-tab title="移出购物车" name="移出购物车"></van-tab>
      <van-tab title="临时" name="临时"></van-tab>
    </van-tabs>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <van-card v-for="(item, index) in list" :key="index" :price="item.dzy_price" :origin-price="item.book.all_amount"
        :desc="item.book_name" :title="item.book.book_name" @click="openUrl(item.isbn, item.dzy_id)"
        :thumb="item.book.book_info ? item.book.book_info.photo_url : ''">
        <div slot="tags">
          <van-tag type="danger"> {{ item.remark }}</van-tag>
          <van-tag type="danger"> 利润：{{ item.difference }}</van-tag>
          <van-tag type="danger"> 购买:{{ item.book.buy_num }},售出:{{ item.book.sold_num }}</van-tag>
        </div>
        <template slot="footer">
          <van-button round size="mini" @click.stop="duozhuayu(item.dzy_id)">查看多抓鱼</van-button>
          <van-button round size="mini" @click.stop="showSoldDialog = true,isbn=item.isbn"
            type="primary">设置出售价</van-button>
          <van-button type="danger" round size="mini" @click.stop="tobuy(item)">移除</van-button>
        </template>
      </van-card>
    </van-list>
    <van-dialog v-model="showSoldDialog" title="设置出售价" show-cancel-button @confirm="setAllAmount">
      <van-field v-model="all_amount" label="出售总价" placeholder="请输入出售总价" />
    </van-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      showSoldDialog: false,
      all_amount: '',
      isbn: '',
      form: {
        page: 0,
        not_buy_type: '全部'
      }
    }
  },
  created () {
    this.form.page = 0
    this.form.dzy_id = this.$route.query.dzyid
    this.form.isbn = this.$route.query.isbn
    this.onLoad()
  },
  methods: {
    async setAllAmount () {
      const { data: res } = await this.$http.get('outOfPrintBook/updatePrice?isbn=' + this.isbn + '&all_amount=' + this.all_amount)
      if (res.code === 200) {
        // this.change()
      }
    },
    async tobuy (item) {
      this.showAction = false
      const { data: res } = await this.$http.get('outOfPrintBook/dzyid/tobuy?id=' + item.id)
      if (res.code === 200) {
        // this.change()
        this.list = this.list.filter(i => i.id !== item.id)
      }
    },

    duozhuayu (dzy_id) {
      window.open('https://www.duozhuayu.com/books/' + dzy_id, '_blank')
    },
    openUrl (isbn, dzy_id) {
      this.$router.push({
        path: '/book',
        query: {
          isbn: isbn,
          dzyid: dzy_id
        }
      })
    },
    change () {
      this.form.page = 0
      this.list = []
      this.onLoad()
    },
    async onLoad () {
      this.loading = true
      this.form.page = this.form.page + 1
      const url = 'outOfPrintBook/dzyid/list'
      const { data: res } = await this.$http.post(url, this.form)
      if (res.code === 200) {
        this.list = this.list.concat(res.data)
        this.loading = false
        res.data.length === 20 ? this.finished = false : this.finished = true
      } else {
        this.finished = true
      }
    }
  },
  components: {}
}
</script>

<style  lang="less"  scoped>
.van-tag {
  margin-left: 5px;
}

.li {
  display: flex;
  width: 100%;
  margin-bottom: 22.4px;
  position: relative;
  overflow: hidden;

  a {
    display: block;
    width: 100%;
    height: 100%;

    .list-img {
      float: left;
      width: 89.6px;
      height: 89.6px;
      text-align: center;
      line-height: 89.6px;
      font-size: 0;
      border: 1px solid #f3f3f3;
      border-radius: 4.48px;
      overflow: hidden;
      margin-right: 16.8px;

      img {
        max-width: 100%;
        max-height: 100%;
        display: inline-block;
      }
    }
  }

  .list-con {
    float: left;
    position: relative;

    a {
      display: block;
      width: 100%;
      height: 100%;

      .title {
        width: 100%;
        line-height: 0.42*56px;
        font-size: 0.3*56px;
        margin-bottom: 0.15*56px;
        color: #262626;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .price-box {
        font-size: 0.24*56px;
        color: #9e100e;
        margin-bottom: 0.14*56px;

        .price {
          font-size: 0.34*56px;
          margin-right: 0.1*56px;
          font-weight: 700;
        }

        .appearance {
          display: inline-block;
          padding: .003*56px 0.1*56px;
          background: #fafafa;
          border-radius: 0.08*56px;
          font-size: 0.22*56px;
          color: #999;
          margin-right: 0.1*56px;
        }
      }
    }
  }

}
</style>
